import React, { FunctionComponent } from 'react';
import Country from '../../../../networking/models/Country';
import EditCard from '../../layout/EditCard';

interface Props {
    country: Country;
    onChange: (country: Country) => void;
    onDelete: (country: Country) => void;
}

const CountryCard: FunctionComponent<Props> = ({ country, onChange, onDelete }) => {

    const onNameChange = (name: string) => {
        onChange({ ...country, name });
    };

    const onDeleteClick = () => onDelete(country);

    return (
        <EditCard value={country.name} onChange={onNameChange} onDelete={onDeleteClick}>
            <span>({ country.universities })</span>
        </EditCard>
    );
};

export default CountryCard;
